import { createFileRoute } from "@tanstack/react-router";
import { NutzerImportSeite } from "@/components/NutzerImportSeite";

/*
 * `/admin/users/import` — der Excel-Voll-Abgleich der Nutzerverwaltung.
 *
 * ═══ Warum ZWEI Unterstriche und nicht einer ══════════════════════════════
 *
 * Der erste löst die Route aus `admin.tsx` heraus, wie bei allen
 * Admin-Unterseiten: sie liegt PFADLICH unter `/admin`, aber nicht in dessen
 * Layout.
 *
 * Der zweite tut dasselbe eine Ebene tiefer, und dort ist er der eigentliche
 * Punkt: ohne ihn hieße die Datei `admin_.users.import.tsx`, und
 * `admin_.users.tsx` würde zur LAYOUT-Route dieser Seite. Die
 * Benutzerverwaltung stünde dann über dem Abgleich — zwei Tabellen
 * übereinander, die dasselbe zeigen —, und `/admin/users` selbst bräuchte eine
 * zusätzliche Index-Route, um überhaupt noch etwas anzuzeigen.
 *
 * Nachgesehen wird das am Generat und nicht geraten: `routeTree.gen.ts` muss
 * `/admin/users/import` in `fullPaths` führen UND `/admin/users` unverändert
 * lassen. Ein Fall in `NutzerImportSeite.test.tsx` hält beides fest.
 *
 * Kein `loader`: die Sicht hat gar keine Abfrage. Sie beginnt mit einem leeren
 * Formular, und alles Weitere entsteht aus zwei Mutationen — es gibt vor dem
 * ersten Klick nichts zu holen.
 */
export const Route = createFileRoute("/admin_/users_/import")({
  component: NutzerImportSeite,
});
